import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import { App } from './App';
import { i18n } from './i18n';
import 'leaflet/dist/leaflet.css';
import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Note: StrictMode is intentionally omitted because react-leaflet's
// MapContainer is incompatible with React 19's strict-mode double-mount.
// Leaflet attaches to the DOM on first mount and does not clean up,
// causing "Map container is already initialized" on the second mount.
// This does NOT affect production builds (StrictMode is dev-only).
ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <Suspense fallback={<div className="flex h-screen items-center justify-center">Loading…</div>}>
          <App />
        </Suspense>
      </BrowserRouter>
    </I18nextProvider>
  </QueryClientProvider>,
);
